import { render, staticRenderFns } from "./ExamPaperMark.vue?vue&type=template&id=3f0f74f1&scoped=true"
import script from "./ExamPaperMark.vue?vue&type=script&lang=js"
export * from "./ExamPaperMark.vue?vue&type=script&lang=js"
import style0 from "./ExamPaperMark.vue?vue&type=style&index=0&id=3f0f74f1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f0f74f1",
  null
  
)

export default component.exports